import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { assetApi, type Asset } from '../../api/media';

export function ApprovalQueuePage() {
  const [items, setItems] = useState<Asset[]>([]);
  const [busyId, setBusyId] = useState('');

  async function load() {
    setItems(await assetApi.list({ status: 'pending_approval' }));
  }

  useEffect(() => { void load(); }, []);

  async function act(id: string, reject: boolean) {
    setBusyId(id);
    try {
      await assetApi.approve(id, { reject });
      await load();
    } finally {
      setBusyId('');
    }
  }

  return (
    <div className="mx-auto max-w-4xl p-6">
      <Link to="/media" className="text-sm text-slate-600 hover:underline">← Library</Link>
      <h1 className="mt-4 text-2xl font-semibold">Approval Queue</h1>
      <ul className="mt-6 space-y-3">
        {items.map((a) => (
          <li key={a.id} className="flex flex-wrap items-center justify-between gap-3 rounded-xl border bg-white p-4">
            <div>
              <Link to={`/media/assets/${a.id}`} className="font-medium hover:underline">{a.name}</Link>
              <p className="text-sm text-slate-500">{a.type}</p>
            </div>
            <div className="flex gap-2">
              <button disabled={busyId === a.id} onClick={() => void act(a.id, false)} className="rounded border px-3 py-1 text-sm">Approve</button>
              <button disabled={busyId === a.id} onClick={() => void act(a.id, true)} className="rounded border px-3 py-1 text-sm">Reject</button>
              <button disabled={busyId === a.id} onClick={() => void assetApi.publish(a.id).then(load)} className="rounded bg-slate-900 px-3 py-1 text-sm text-white">Publish</button>
            </div>
          </li>
        ))}
        {items.length === 0 && <p className="text-slate-500">No assets pending approval.</p>}
      </ul>
    </div>
  );
}
